import getEventElement, {
  Options as GetElementOptions
} from './getEventElement';
import { Event } from '../constants';
import type { MayNudgeShowResult } from '../contracts';
import type Result from '../Result';

type Options = {
  /** Enable debug logging */
  debug?: boolean;

  /** Options to get the event element */
  getElementOptions?: GetElementOptions;

  /** Timeout in milliseconds before giving up on the request for permission */
  timeout?: number;
};

export default async function mayNudgeShow(
  nudgeId: string,
  { debug, getElementOptions, timeout = 10000 }: Options = {}
): Promise<Result> {
  const eventEl = await getEventElement(getElementOptions);

  if (!eventEl) {
    throw new Error('Nudge Manager not running in application.');
  }

  return new Promise<Result>((resolve, reject) => {
    if (debug) {
      console.debug('Requesting if nudge may show', nudgeId);
    }

    eventEl.dispatchEvent(
      new CustomEvent<string>(Event.MayNudgeShow, {
        detail: nudgeId
      })
    );

    const t = window.setTimeout(() => {
      reject(new Error('Timeout requesting if nudge may show.'));
    }, timeout);

    eventEl.addEventListener<any>(
      Event.MayNudgeShowResult,
      (e: CustomEvent<MayNudgeShowResult>) => {
        if (debug) {
          console.debug('Response to nudge request arrived', e.detail);
        }

        if (nudgeId === e.detail.nudgeId) {
          resolve(e.detail.result);
          clearTimeout(t);
        }
      }
    );
  });
}
